module.exports = __webpack_public_path__ + "static/CS_web_developer_blue-9da0cb5b0a5c103b7cb678219ef8c44f.png";